function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
import regeneratorRuntime from "regenerator-runtime";
import { getAuth } from "firebase/auth";
import { collection, doc, getFirestore, onSnapshot } from "firebase/firestore";
import { activeEventsClient } from "../generated/active_events";
import { ensureClientInitialized } from "./firebase";
import { parseActiveEventFromDocument } from "./types/activeEvents";
var FIREBASE_APP_NAME = "Global";
var unsubscribeFunctions = [];
var fetchFirebaseConfig = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var ref, firebaseConfig;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return activeEventsClient.activeEventService.getActiveEventsFirebaseConfig({});
                case 3:
                    firebaseConfig = _ctx.sent;
                    return _ctx.abrupt("return", {
                        authToken: firebaseConfig.authToken,
                        options: firebaseConfig.config,
                        proxyDomain: ((ref = firebaseConfig.config) === null || ref === void 0 ? void 0 : ref.proxyDomain) || ""
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchFirebaseConfig() {
        return _ref.apply(this, arguments);
    };
}();
export var setActiveEventsListener = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(listener) {
        var firebaseConfig, isLoggedIn, firebaseClient, auth, activeEventFirestoreClient;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchFirebaseConfig();
                case 2:
                    firebaseConfig = _ctx.sent;
                    isLoggedIn = firebaseConfig.authToken && firebaseConfig.authToken.length > 0;
                    if (isLoggedIn) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 6:
                    _ctx.next = 8;
                    return ensureClientInitialized(FIREBASE_APP_NAME, firebaseConfig);
                case 8:
                    firebaseClient = _ctx.sent;
                    auth = getAuth(firebaseClient);
                    if (auth.currentUser) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 12:
                    activeEventFirestoreClient = new ActiveEventFirestoreClient(firebaseClient);
                    unsubscribeFunctions.push(onSnapshot(activeEventFirestoreClient.getActiveEventsCollection(auth.currentUser.uid), function(q) {
                        var events = q.docs.map(function(d) {
                            return parseActiveEventFromDocument(d);
                        });
                        listener(events.filter(function(ev) {
                            return ev != null;
                        }));
                    }));
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function setActiveEventsListener(listener) {
        return _ref.apply(this, arguments);
    };
}();
export var clearActiveEventsListeners = function() {
    unsubscribeFunctions.forEach(function(unsubscribe) {
        return unsubscribe();
    });
    unsubscribeFunctions = [];
};
var ActiveEventFirestoreClient = function ActiveEventFirestoreClient(app) {
    "use strict";
    var _this = this;
    _classCallCheck(this, ActiveEventFirestoreClient);
    this.getUserDocument = function(userId) {
        return doc(collection(getFirestore(_this.app), "users"), userId);
    };
    this.getActiveEventsCollection = function(userId) {
        return collection(_this.getUserDocument(userId), "activeEvents");
    };
    this.app = app;
};
